module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiboldIt.66084e0.woff";